<template>
  <!-- 添加框 -->
  <el-dialog title="采购车信息" :visible.sync="shoCarAddFlag" size="tiny" class="shopCar_dialog">
    <el-form :model="form" :rules="rules" ref="ruleForm" class="shopCar_add">
      <el-form-item label="SKU号" :label-width="formLabelWidth">
        <el-input v-model="form.productId" auto-complete="off" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item class="shopAddDesc">
        <div class="descImg">
          <div>
            <img :src="form.imagePath" alt />
          </div>
          <div>
            {{form.goodsName}}
            <span style="display:block; color: #A2A2A2;">规格: {{ form.specName}}</span>
            <span style="display:block; color: #A2A2A2;">SKU: {{ form.productId}}</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="数量" :label-width="formLabelWidth">
        <el-input-number
          size="mini"
          v-model="form.num1"
          :min="1"
          label="描述文字"
          class="selectAdd"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="收件人姓名" :label-width="formLabelWidth" prop="linkMan">
        <el-input v-model="form.linkMan" auto-complete="off" placeholder="请输入收件人姓名"></el-input>
      </el-form-item>
      <el-form-item label="收件人电话" :label-width="formLabelWidth" prop="mobile">
        <el-input type="text" v-model="form.mobile" auto-complete="off" placeholder="请输入收件人电话"></el-input>
      </el-form-item>
      <!-- change-on-select -->
      <el-form-item label="收件人地址" :label-width="formLabelWidth" prop="homeAdress">
        <el-cascader
          :options="options"
          change-on-select
          size="265px"
          v-model="form.homeAdress"
          placeholder="请选择省/市/区"
        ></el-cascader>
        <!-- <el-input type="textarea" v-model="form.address"></el-input> -->
      </el-form-item>
      <el-form-item label="详细地址" prop="address" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.address" placeholder></el-input>
      </el-form-item>
      <el-form-item label="自有订单号" :label-width="formLabelWidth">
        <el-input v-model="form.ownerOrderSn" auto-complete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onCancle('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="onCertain('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { carAdress, carJoinCar, CarOrderUpdate } from "../config/interface.js";
import { fetch, baseURL } from "../config/fetch.js";
import { toast } from "../util/tool.js";
import router from "../router/index.js";
export default {
  data() {
    let mobileValidate = (rule, value, callback) => {
      let isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
      let isMobile = /^1[3456789]\d{9}$/;
      if (!value) {
        callback(new Error("手机号不能为空"));
      } else if (!isPhone.test(value) && !isMobile.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    let homeAdressValidate = (rule, value, callback) => {
      //   console(value);
      console.log(value);
      if (!value) {
        callback(new Error("省/市/区必填"));
      } else if (value.length != 3) {
        callback(new Error("请填写省市区"));
      } else {
        callback();
      }
    };
    return {
      userId: this.$store.state.userId,
      appId: this.$store.state.appId,
      platformName: this.$store.state.platformName,
      num1: 1,
      value8: "",
      desc: "",
      tag: 1, //默认是1 若为0这是修改的接口
      shoCarAddFlag: false,
      formLabelWidth: "120px",
      form: {
        homeAdress: null,
        num1: null,
        productId: null,
        imagePath: null,
        goodsName: null,
        storeNum: null,
        linkMan: null,
        mobile: null,
        province: null,
        city: "",
        area: "",
        address: "",
        specName: "",
        id: null,
        ownerOrderSn: null,
      },
      rules: {
        linkMan: [{ required: true, message: "联系人必填", trigger: "blur" }],
        mobile: [
          { required: true, validator: mobileValidate, trigger: "blur" }
        ],
        homeAdress: [
          { required: true, validator: homeAdressValidate, trigger: "change" }
        ],
        address: [{ required: true, message: "详细地址必填", trigger: "blur" }]
      },
      options: []
    };
  },
  methods: {
    init(row, value) {
      console.log("init");
      console.log(row);
      console.log(value);
      // console.log(index1);
      this.changeAddShowFlag();
      this.selectPro();
      if (value == 0) {
        this.tag = 0;
        let adress = [row.province, row.city, row.area];
        // let adress=row.province+'/'+row.city+'/'+row.area;
        // 订单修改的页面
        this.form.productId = row.productId;
        this.form.imagePath = row.specImage;
        this.form.goodsName = row.goodsName;
        this.form.specName = row.specName;
        this.form.num1 = row.quantity;
        this.form.storeNum = row.maxSingleQuantity;
        this.form.linkMan = row.linkMan;
        this.form.mobile = row.mobile;
        this.form.homeAdress = adress;
        this.form.address = row.address;
        this.form.id = row.id;
        this.form.ownerOrderSn = row.ownerOrderSn;

        return;
      }
      this.tag = 1;
      //   0是不带票 1是带票 若0库存数取availableNum 若为 1：库存数取：availableTaxNum
      //   alert(value.shelvesVo[0])
      this.form.productId = value.skuId;
      this.form.imagePath = value.pictureUrl;
      this.form.goodsName = row.goodsName;
      this.form.specName = value.specName;
      this.form.apiType = value.apiType;
      this.form.num1 = 1;
      //   this.form.gui=row.
      let hasTax = row.shelvesProduct[0].shelvesVo[0].hasTax;

      if (hasTax == 0) {
        this.form.storeNum = row.availableNum;
      } else {
        this.form.storeNum = row.availableTaxNum;
      }
    },

    selectPro() {
      console.log("调用了省市区");
      let url = carAdress;
      let params = {
        userId: this.userId,
        bodyId: this.$store.state.bodyId,
        appId: this.$store.state.appId,
      };
      fetch(url, params).then(res => {
        let citysArr = [];
        if (res.code == 10000) {
          res.data.forEach((value, index) => {
            let pro = {};
            pro.value = value.proName;
            pro.label = value.proName;
            pro.children = [];
            value.citys.forEach((city, index) => {
              let city1 = {};
              city1.value = city.cityName;
              city1.label = city.cityName;
              pro.children.push(city1);
              city1.children = [];

              city.areas.forEach((area, index) => {
                let area1 = {};
                area1.value = area.areaName;
                area1.label = area.areaName;
                city1.children.push(area1);
              });
            });
            citysArr.push(pro);
            //    console.log()
          });
          this.options = citysArr;
          console.log("获取省份");
          console.log(res.data);
        }
      });
    },
    // 对话框是否显示
    changeAddShowFlag() {
      this.shoCarAddFlag = !this.shoCarAddFlag;
    },
    onCertain(formName) {
      let _this = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.tag == 0) {
            //  修改页面的功能
            _this.upDateSuccess();
          } else {
            //   添加购物车的功能
            _this.carJoninSuccess();
          }
        } else {
          return false;
        }
      });
    },
    upDateSuccess() {
      let url = CarOrderUpdate;
      let params = {
        userId: this.userId,
        appId: this.appId,
        purchasingCarts: [
          {
            address: this.form.address,
            appOrderSn: "无",
            province: this.form.homeAdress[0],
            city: this.form.homeAdress[1],
            area: this.form.homeAdress[2],
            goodsName: this.form.goodsName,
            linkMan: this.form.linkMan,
            mobile: this.form.mobile,
            orderSources: this.platformName,
            id: this.form.id,
            quiantity: this.form.num1.toString(),
            remark: "",
            appType: this.form.apiType,
            ownerOrderSn: this.form.ownerOrderSn,
          }
        ]
      };
      fetch(url, params).then(res => {
        console.log("保存的接口");
        console.log(res);
        if (res.code == 10000) {
          toast("修改成功", 1, false);
          this.changeAddShowFlag();
          this.$emit("updateListItem");
          this.$refs["ruleForm"].resetFields();
        }
      });
    },
    carJoninSuccess() {
      // alert(1);
      // homeAdress 数组[省，市，区];
      let url = carJoinCar;
      let params = {
        userId: this.userId,
        appId: this.appId,
        purchasingCarts: [
          {
            address: this.form.address,
            appOrderSn: "无",
            province: this.form.homeAdress[0],
            city: this.form.homeAdress[1],
            area: this.form.homeAdress[2],
            goodsName: this.form.goodsName,
            linkMan: this.form.linkMan,
            mobile: this.form.mobile,
            orderSources: this.platformName,
            productId: this.form.productId,
            quiantity: this.form.num1.toString(),
            remark: "",
            //4社群集采 3一件代发
            deliveryWay:+this.form.apiType==2?4:3,
            appType: this.form.apiType,
            ownerOrderSn: this.form.ownerOrderSn
          }
        ]
      };
      console.log("确定的参数");
      console.log(params);
      fetch(url, params).then(res => {
        console.log(res);
        if (res.code == 10000) {
          toast("成功加入采购车", 1, false);
          this.changeAddShowFlag();
          this.$emit("updateListItem");
          this.$refs["ruleForm"].resetFields();
          // this.form.homeAdress=null;
          // this.form.address=null;
        }
      });
    },
    // 取消按钮
    onCancle() {
      this.changeAddShowFlag();
      // this.$emit('updateListItem');
      this.$refs["ruleForm"].resetFields();
    }
  }
};
</script>
<style>
.shopCar_dialog .el-input-number--mini {
  width: 117px;
}
.shopCar_dialog .selectAdd .el-input__inner {
  background-color: #eeeeee;
  width: 118px;
  padding-right: 0px;
  /* background-color: #D6D6D6; */
  position: relative;
  left: -31px;
  /* padding-left: 46px; */
}
.shopCar_dialog .selectAdd span.el-input-number__decrease {
  left: 0px;
  border-right: 1px solid #d6d6d6;
}
.shopCar_dialog .el-input--mini {
  padding-left: 30px;
}
.shopCar_add .el-form-item:nth-child(3) .el-form-item__label {
  text-align: center;
  padding-left: 12px;
}
.shopCar_add .el-form-item:nth-child(6) .el-input__inner {
  font-size: 12px;
  width: 265px;
  padding-right: 20px;
}
.shopCar_add .el-form-item:nth-child(6) .el-input__icon {
  width: 20px;
}
.shopAddDesc {
  position: relative;
  margin-left: 20px;
  font-size: 12px;
}
.descImg div:nth-of-type(1) {
  width: 60px;
  height: 84px;
  /* border: 1px solid red; */
  margin-left: 21px;
  display: inline-block;
  float: left;
}
.descImg div:nth-of-type(1) > img {
  width: 60px;
  height: 84px;
}
.descImg div:nth-of-type(2) {
  display: inline-block;
  height: 84px;
  /* margin-left:22px; */
  font-size: 12px;
  /* border: 1px solid red; */
  width: 275px;
  margin-left: 5px;
  line-height: 23px;
}
.dialog-footer {
  width: 265px;
  /* border: 1px solid red; */
  height: 40px;
  margin: 0 auto;
}
.shopCar_dialog .el-button {
  /* float:right; */
  background-color: #fff;
  color: #fea923;
  border: 1px solid #fea923;
  margin-bottom: 20px;
  width: 100px;
  text-align: center;
}
.shopCar_dialog .el-dialog__body {
  margin-bottom: -20px;
}
.shopCar_dialog .el-button.el-button--primary {
  background-color: #fea923;
  color: #fff;
  float: left;
  /* margin-left: 88px; */
}
.shopCar_dialog .el-form-item__label {
  font-size: 12px;
  color: #a2a2a2;
}
.shopCar_dialog input::-webkit-input-placeholder {
  color: #a2a2a2;
  font-size: 12px;
}
</style>





// WEBPACK FOOTER //
// ShopCarAdd.vue?43cf331f